import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterModule } from '@angular/router';
import { AlertCardComponent } from '../../../shared/components/alert-card/alert-card.component';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { LoadingBoxDefaultListComponent } from '../../../shared/components/loading-box-default-list/loading-box-default-list.component';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { PermissaoEnum } from '../../../shared/enums/usuario/permissao.enum';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { AuthService } from '../../../shared/services/apis/usuario/auth.service';
import { ServicoTomadoService } from '../../../shared/services/apis/repo-dfse/servico-tomado.service';
import { ServicoTomadoListaRequest } from '../../../shared/services/requests/repo-dfse/servico-tomado-lista.request';
import { GetAllServicoTomadoResponse } from '../../../shared/services/responses/repo-dfse/get-all-servico-tomado.response';
import { ServicoTomadoListStruct } from '../../../shared/services/structs/repo-dfse/servico-tomado-list.struct';
import { UtilService } from '../../../shared/services/util.service';
import { AbntPipe } from '../../../shared/pipes/abnt.pipe';
import { UiTagComponent } from '../../../shared/components/ui-tag/ui-tag.component';
import { TagServicoTomadoService } from '../../../shared/services/apis/repo-dfse/tag-servico-tomado.service';
import { TagServicoTomadoItemStruct } from '../../../shared/services/structs/repo-dfse/tag-servico-tomado-item.struct';
import { ServicoTomadoLookupService } from '../../../shared/services/apis/repo-dfse/servico-tomado-lookup.service';
import { StatusFiscalNFSeEntradaLookupStruct } from '../../../shared/services/structs/repo-dfse/status-fiscal-nfse-entrada-lookup.struct';
import { StatusFiscalNFSeEntradaEnum } from '../../../shared/enums/repo-dfse/status-fiscal-nfse-entrada.enum';
import { TipoIntegracaoEnum, TipoIntegracaoIndicador } from '../../../shared/enums/repo-dfse/tipo-integracao.enum';
import { ServicoTomadoContasService } from '../../../shared/services/apis/orquestrador-financas/servico-tomado-contas.service';
import { ImpressaoServicoTomadoDialogComponent } from './dialogs/impressao-servico-tomado-dialog/impressao-servico-tomado-dialog.component';
import { AlterarTagsDialogComponent } from './dialogs/alterar-tags-dialog/alterar-tags-dialog.component';
import { LancarFinanceiroDialogComponent } from './dialogs/lancar-financeiro-dialog/lancar-financeiro-dialog.component';
import { ExcluirFinanceiroDialogComponent } from './dialogs/excluir-financeiro-dialog/excluir-financeiro-dialog.component';
import { HistoricoServicoTomadoDialogComponent } from './dialogs/historico-servico-tomado-dialog/historico-servico-tomado-dialog.component';
import { HistoricoServicoTomadoDialogData } from './dialogs/historico-servico-tomado-dialog/historico-servico-tomado-dialog-data';
import { ExcluirFinanceiroServicoTomadoRequest } from '../../../shared/services/requests/orquestrador-financas/excluir-financeiro-servico-tomado.request';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';

export enum PeriodoServicoTomadoEnum {
  Hoje = 1,
  DaSemana = 2,
  DoMes = 3,
  Ultimos30Dias = 4,
  DoIntervalo = 5,
}

@Component({
  selector: 'app-servico-tomado-lista',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatMenuModule,
    MatSelectModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    MatBadgeModule,
    MatTooltipModule,
    EmptyListComponent,
    RouterModule,
    LoadingBoxDefaultListComponent,
    AlertCardComponent,
    AbntPipe,
    UiTagComponent,
  ],
  templateUrl: './servico-tomado-lista.component.html',
  styleUrls: ['./servico-tomado-lista.component.css'],
})
export class ServicoTomadoListaComponent implements OnInit, OnDestroy {
  @ViewChild('periodoMenuTrigger') periodoMenuTrigger?: MatMenuTrigger;

  public moduloEnum = ModuloEnum.Suprimentos;
  public funcionalidadeEnum = FuncionalidadeEnum.Suprimentos_ServicosTomados;
  public permissaoEnum = PermissaoEnum;

  public PeriodoServicoTomadoEnum = PeriodoServicoTomadoEnum;
  public statusOpcoes: StatusFiscalNFSeEntradaLookupStruct[] = [];

  public model!: FormGroup;
  public _isLoading = false;

  public periodoSelecionado: PeriodoServicoTomadoEnum = PeriodoServicoTomadoEnum.DoMes;
  private periodoMenuFoiAplicado = true;

  public displayedColumns: string[] = [
    'numero', 'emitente', 'emissao', 'entrada', 'status', 'tags', 'valorTotal', 'valorLiquido', 'integracao', 'actions'
  ];

  public listaTags: TagServicoTomadoItemStruct[] = [];

  public _listaResponse: GetAllServicoTomadoResponse | undefined;
  public _dataSource = new MatTableDataSource<ServicoTomadoListStruct>();
  public _paginaAtual = 0;
  public _ultimaPagina = false;

  public podeInserir = false;
  public podeAlterar = false;
  public podeExcluir = false;
  /** Permissão 176: só exclui o financeiro; lançar vale para quem pode inserir o serviço tomado. */
  public podeExcluirFinanceiro = false;

  constructor(
    private formBuilder: FormBuilder,
    private servicoTomadoService: ServicoTomadoService,
    private tagServicoTomadoService: TagServicoTomadoService,
    private servicoTomadoLookupService: ServicoTomadoLookupService,
    private servicoTomadoContasService: ServicoTomadoContasService,
    private alertService: AlertService,
    private dialog: MatDialog,
    private utilService: UtilService,
    private authService: AuthService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.model = this.formBuilder.group({
      pesquisa: [''],
      dataDe: [null],
      dataAte: [null],
      idStatusFiscalNFSeEntrada: [null as number | null],
    });

    const usuario = this.authService.getUserInfos();
    this.podeInserir = usuario?.listaPermissoes?.includes(this.permissaoEnum.Suprimentos_ServicosTomados_Inserir);
    this.podeAlterar = usuario?.listaPermissoes?.includes(this.permissaoEnum.Suprimentos_ServicosTomados_Alterar);
    this.podeExcluir = usuario?.listaPermissoes?.includes(this.permissaoEnum.Suprimentos_ServicosTomados_Excluir);
    this.podeExcluirFinanceiro = usuario?.listaPermissoes?.includes(this.permissaoEnum.Suprimentos_ServicosTomados_ExcluirFinanceiro);

    this.loadFilters();
    if (!this.model.get('dataDe')?.value) {
      this.calcularDatasParaPeriodo(this.periodoSelecionado);
    }
    this.pesquisar();
    this.carregarTags();
    this.carregarStatus();
  }

  private carregarStatus(): void {
    this.servicoTomadoLookupService.getStatusFiscal().subscribe(res => {
      if (!res.isError) {
        this.statusOpcoes = res.list || [];
      }
    });
  }

  private carregarTags(): void {
    this.tagServicoTomadoService.getAll('', 1, 500).subscribe(res => {
      if (!res.isError) {
        this.listaTags = (res.listaTags || []).map(t => ({ id: t.idTagServicoTomado, descricao: t.descricao, cor: t.cor }));
      }
    });
  }

  ngOnDestroy(): void {
    this.utilService.salvarFiltro(this.moduloEnum, this.funcionalidadeEnum, this.model, []);
  }

  private loadFilters(): void {
    const filtroSalvo = this.utilService.obterFiltro(this.moduloEnum, this.funcionalidadeEnum);
    if (filtroSalvo) {
      this.model.patchValue(filtroSalvo);
    }
  }

  public get qtdFiltrosStatus(): number {
    return this.model.get('idStatusFiscalNFSeEntrada')?.value != null ? 1 : 0;
  }

  public aplicarFiltros(): void {
    this.clickPesquisar();
  }

  public limparFiltros(): void {
    this.model.patchValue({ pesquisa: '', dataDe: null, dataAte: null, idStatusFiscalNFSeEntrada: null });
    this.periodoSelecionado = PeriodoServicoTomadoEnum.DoMes;
    this.calcularDatasParaPeriodo(this.periodoSelecionado);
    this.clickPesquisar();
  }

  // --- Período ---

  public get periodoLabel(): string {
    switch (this.periodoSelecionado) {
      case PeriodoServicoTomadoEnum.Hoje: return 'hoje';
      case PeriodoServicoTomadoEnum.DaSemana: return 'desta semana';
      case PeriodoServicoTomadoEnum.DoMes: return 'do mês';
      case PeriodoServicoTomadoEnum.Ultimos30Dias: return 'últimos 30 dias';
      case PeriodoServicoTomadoEnum.DoIntervalo: return 'do intervalo';
      default: return 'do mês';
    }
  }

  public prepararPeriodoIntervalo(): void {
    this.periodoMenuFoiAplicado = false;
  }

  public onPeriodoMenuClosed(): void {
    if (!this.periodoMenuFoiAplicado) {
      this.periodoMenuFoiAplicado = true;
    }
  }

  public selecionarPeriodo(periodo: PeriodoServicoTomadoEnum): void {
    this.periodoSelecionado = periodo;
    if (periodo !== PeriodoServicoTomadoEnum.DoIntervalo) {
      this.calcularDatasParaPeriodo(periodo);
    }
  }

  private calcularDatasParaPeriodo(periodo: PeriodoServicoTomadoEnum): void {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    let dataDe: Date;
    let dataAte: Date;

    switch (periodo) {
      case PeriodoServicoTomadoEnum.Hoje:
        dataDe = new Date(hoje);
        dataAte = new Date(hoje);
        break;
      case PeriodoServicoTomadoEnum.DaSemana: {
        dataDe = new Date(hoje);
        dataDe.setDate(hoje.getDate() - hoje.getDay());
        dataAte = new Date(dataDe);
        dataAte.setDate(dataDe.getDate() + 6);
        break;
      }
      case PeriodoServicoTomadoEnum.DoMes: {
        dataDe = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
        dataAte = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
        break;
      }
      case PeriodoServicoTomadoEnum.Ultimos30Dias:
      default: {
        dataDe = new Date(hoje);
        dataDe.setDate(hoje.getDate() - 30);
        dataAte = new Date(hoje);
        break;
      }
    }

    this.model.patchValue({ dataDe, dataAte });
  }

  public aplicarPeriodo(trigger?: MatMenuTrigger): void {
    if (this.periodoSelecionado === PeriodoServicoTomadoEnum.DoIntervalo) {
      this.model.get('dataDe')?.markAsTouched();
      this.model.get('dataAte')?.markAsTouched();

      if (!this.model.get('dataDe')?.value || !this.model.get('dataAte')?.value) {
        this.alertService.show('Atenção', 'Preencha as duas datas do intervalo.', AlertType.warning);
        return;
      }
      if (new Date(this.model.get('dataAte')?.value) < new Date(this.model.get('dataDe')?.value)) {
        this.alertService.show('Atenção', 'A data final não pode ser menor que a data inicial.', AlertType.warning);
        return;
      }
    }

    this.periodoMenuFoiAplicado = true;
    const menuTrigger = trigger ?? this.periodoMenuTrigger;
    setTimeout(() => menuTrigger?.closeMenu());
    this.clickPesquisar();
  }

  public cancelarPeriodoIntervalo(trigger?: MatMenuTrigger): void {
    this.periodoMenuFoiAplicado = true;
    const menuTrigger = trigger ?? this.periodoMenuTrigger;
    setTimeout(() => menuTrigger?.closeMenu());
  }

  // --- Busca / paginação ---

  private getFiltrosRequest(): ServicoTomadoListaRequest {
    const request = new ServicoTomadoListaRequest();
    request.searchText = this.model.get('pesquisa')?.value;
    const idStatusFiscalNFSeEntrada: number | null = this.model.get('idStatusFiscalNFSeEntrada')?.value;
    request.listIdStatusFiscalNFSeEntrada = idStatusFiscalNFSeEntrada != null ? [idStatusFiscalNFSeEntrada] : undefined;

    const dataDe = this.model.get('dataDe')?.value;
    const dataAte = this.model.get('dataAte')?.value;
    if (dataDe) request.dataEmissaoInicio = new Date(dataDe).toISOString();
    if (dataAte) request.dataEmissaoFim = new Date(dataAte).toISOString();

    return request;
  }

  public pesquisar(): void {
    if (this._isLoading) return;
    this._isLoading = true;

    const request = this.getFiltrosRequest();

    // Via orquestrador: ele devolve a listagem do RepoDFSe, já com a flag de financeiro lançado
    // do próprio documento (isFinanceiroLancado).
    this.servicoTomadoContasService.getAll(request, this._paginaAtual).subscribe({
      next: (response) => {
        this._isLoading = false;
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        if (!this._listaResponse) {
          this._listaResponse = response;
          this._dataSource.data = response.list;
        } else {
          this._listaResponse.list.push(...response.list);
          this._dataSource.data = this._listaResponse.list;
        }

        this._ultimaPagina = !response.list?.length || this._dataSource.data.length >= response.fullListSize;
      },
      error: (err) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
      }
    });
  }

  public clickPesquisar(): void {
    this._paginaAtual = 0;
    this._listaResponse = undefined;
    this._dataSource.data = [];
    this._ultimaPagina = false;
    this.pesquisar();
  }

  public proximaPagina(): void {
    this._paginaAtual++;
    this.pesquisar();
  }

  public statusBadgeClass(id?: number): string {
    if (id === StatusFiscalNFSeEntradaEnum.Cancelada) return 'status-badge badge-vermelho';
    if (id === StatusFiscalNFSeEntradaEnum.Regular) return 'status-badge badge-verde';
    return 'status-badge badge-cinza';
  }

  public statusLabel(id?: number): string {
    return this.statusOpcoes.find(s => s.id === id)?.descricao ?? '—';
  }

  /** Indicadores da coluna Integração: a letra F só quando o financeiro está lançado. */
  public integracoes(row: ServicoTomadoListStruct): { sigla: string; rotulo: string; cor: string }[] {
    const indicadores: { sigla: string; rotulo: string; cor: string }[] = [];
    if (row.isFinanceiroLancado) {
      const financeiro = TipoIntegracaoIndicador[TipoIntegracaoEnum.Financeiro];
      indicadores.push({ sigla: financeiro.sigla, rotulo: 'Financeiro lançado', cor: financeiro.cor });
    }
    return indicadores;
  }

  public verHistorico(row: ServicoTomadoListStruct): void {
    const data = new HistoricoServicoTomadoDialogData();
    data.idNFSeEntrada = row.idNFSeEntrada;
    data.titulo = `NFS-e ${row.numeroNFSe || '-'}${row.serieDps ? ` / ${row.serieDps}` : ''}`;
    this.dialog.open(HistoricoServicoTomadoDialogComponent, {
      width: '640px',
      maxWidth: '96vw',
      autoFocus: false,
      data,
    });
  }

  /**
   * Abre o lançamento do financeiro. O menu só oferece esta ação quando o financeiro não está
   * lançado; lançado, a opção que aparece é "Excluir financeiro".
   */
  public lancarFinanceiro(row: ServicoTomadoListStruct): void {
    const dialogRef = this.dialog.open(LancarFinanceiroDialogComponent, {
      width: '760px',
      maxWidth: '95vw',
      data: { idNFSeEntrada: row.idNFSeEntrada },
    });

    dialogRef.afterClosed().subscribe(lancou => {
      if (lancou) this.clickPesquisar();
    });
  }

  /**
   * Exclui o financeiro: apaga a conta a pagar gerada pela nota, com justificativa, como na NF-e
   * de entrada. Tudo ou nada: parcela paga ou liquidada faz o Finanças recusar a exclusão.
   */
  public excluirFinanceiro(row: ServicoTomadoListStruct): void {
    const dialogRef = this.dialog.open(ExcluirFinanceiroDialogComponent, {
      width: '560px',
      maxWidth: '95vw',
      disableClose: true,
      data: { numeroNFSe: row.numeroNFSe || '' },
    });

    dialogRef.afterClosed().subscribe((justificativa?: string) => {
      if (!justificativa) return;
      const request = new ExcluirFinanceiroServicoTomadoRequest();
      request.justificativa = justificativa;

      this.servicoTomadoContasService.excluir(row.idNFSeEntrada, request).subscribe({
        next: (res) => {
          if (res.isError) {
            this.alertService.show('Atenção', res.errorDescription, AlertType.warning);
          } else if (res.avisoDescricao) {
            this.alertService.show('Atenção', res.avisoDescricao, AlertType.warning);
          } else {
            this.alertService.show('Sucesso', 'Financeiro excluído com sucesso.', AlertType.success);
          }
          this.clickPesquisar();
        },
        error: () => {
          this.alertService.show('Erro', 'Não foi possível excluir o financeiro.', AlertType.error);
          this.clickPesquisar();
        }
      });
    });
  }

  /**
   * Exclui a nota. Com o financeiro lançado o menu desabilita a ação; o servidor também recusa e
   * orienta a excluir o financeiro antes.
   */
  public excluir(row: ServicoTomadoListStruct): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Excluir serviço tomado',
        description: `O serviço tomado ${row.numeroNFSe || ''} será excluído. Deseja continuar?`,
        buttonConfirm: 'Excluir',
        buttonClose: 'Cancelar',
        showTextarea: true,
        textareaLabel: 'Justificativa da exclusão',
        textareaRequired: false,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result?.confirm) return;

      this.servicoTomadoContasService.excluirServicoTomado(row.idNFSeEntrada, result.textareaValue).subscribe({
        next: (res) => {
          if (res.isError) {
            this.alertService.show('Erro', res.errorDescription, AlertType.error);
            return;
          }
          this.alertService.show('Sucesso', 'Serviço tomado excluído com sucesso.', AlertType.success);
          this.clickPesquisar();
        },
        error: () => this.alertService.show('Erro', 'Falha ao excluir o serviço tomado.', AlertType.error)
      });
    });
  }

  /**
   * Editar exige o financeiro excluído: alterar valores ou parcelas depois de gerada a conta
   * deixaria os dois divergentes. Com o financeiro lançado o menu desabilita a ação.
   */
  public editar(row: ServicoTomadoListStruct): void {
    this.router.navigate(['/suprimentos/servicos-tomados/editar', row.idNFSeEntrada]);
  }

  public imprimir(row: ServicoTomadoListStruct): void {
    this.dialog.open(ImpressaoServicoTomadoDialogComponent, {
      width: '800px',
      maxWidth: '95vw',
      data: { idNFSeEntrada: row.idNFSeEntrada },
    });
  }

  public editarTags(row: ServicoTomadoListStruct): void {
    const dialogRef = this.dialog.open(AlterarTagsDialogComponent, {
      width: '500px',
      maxWidth: '95vw',
      data: {
        idsNFSeEntrada: [row.idNFSeEntrada],
        tags: this.listaTags,
        idsTagsAtuais: (row.tags || []).map(t => t.idTagServicoTomado),
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.success) {
        this.clickPesquisar();
      }
    });
  }
}
